import React from "react";
import moment from "moment";
import get from "lodash/get";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Layout,
  Form,
  Input,
  Select,
  Icon,
  Radio,
  Button,
  DatePicker,
  Alert,
  Modal,
  Switch,
  message,
  Tooltip,
} from "antd";

import {
  createSAERequest,
  updateSAERequest,
  toggleActivateSAERequest,
  deleteSAERequest,
  getSitesRequest,
  lockSAERequest,
  unlockSAERequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getSAEUpdatePermissionBySite,
  getSAEUpdatePermission,
  getSAEDeletePermissionBySite,
  getSAELockPermission,
  getSAEUnlockPermission,
  getUserTimezone,
  getUserShortTimezone,
  getSAECentralCommentsReadPermission,
  getSAECentralCommentsUpdatePermission,
  getSAETermCodesViewPermission,
  getSAETermCodesUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./SAEReportingForm.css";

const { Option } = Select;

class SAEReportingForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      requestResult: {},
      wasCreated: false,
      saeState: "",
      subjectID: "",
      id: "",
      deleteSubmitModal: false,
      sites: [],
      locked: false,
    };
  }

  async componentDidMount() {
    this.setState({
      saeState: this.props.state,
      locked: get(this.props, "locked"),
    });

    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const { SAEUpdatePermissionBySite, SAEUpdatePermission, SAETermCodesUpdatePermission } = this.props;

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        if (this.props.sae_date && !(SAEUpdatePermissionBySite || SAETermCodesUpdatePermission)) {
          return;
        }
        if (
          (this.props.sae_date || this.state.wasCreated) &&
          !(SAEUpdatePermission || SAETermCodesUpdatePermission)
        ) {
          return;
        }

        this.setState({ isLoading: true });
        try {
          const sae = cloneDeep(values);
          if (values.sae_date) {
            const date = cloneDeep(values.sae_date);
            sae.sae_date = moment
              .tz(
                date.format("YYYY-MM-DDT") + "12:00",
                this.props.userTimezone ||
                  get(
                    find(
                      this.state.sites,
                      ({ id }) =>
                        id === this.props.form.getFieldValue("site_id")
                    ),
                    "time_zone"
                  ) ||
                  "UTC"
              )
              .utc()
              .format("YYYY-MM-DDTHH:mm");
          }

          sae.is_sae_occurred =
            values.is_sae_occurred === "true"
              ? true
              : values.is_sae_occurred === "false"
              ? false
              : null;
          sae.is_adverse_event_expected =
            values.is_adverse_event_expected === "true"
              ? true
              : values.is_adverse_event_expected === "false"
              ? false
              : null;
          sae.suadr = values.suadr || undefined;
          sae.subjectID = undefined;
          sae.site_id = +sae.site_id || get(this.props, "site.id");
          sae.sae_related =
            sae.sae_related === "true"
              ? true
              : sae.sae_related === "false"
              ? false
              : undefined;

          if (this.props.sae_date || this.state.wasCreated) {
            await updateSAERequest(
              get(this.props, "subject.code", this.state.subjectID),
              get(this.props, "id", this.state.id),
              sae
            );
            this.setState({
              isLoading: false,
              requestResult: { type: "success", message: "Success" },
            });
          } else {
            const { data } = await createSAERequest(
              this.props.form.getFieldValue("subjectID"),
              sae
            );
            this.setState({
              wasCreated: true,
              id: data.id,
              subjectID: this.props.form.getFieldValue("subjectID"),
            });
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: "Success" },
          });
        } catch (e) {
          console.log(e.response);
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(
                e,
                "response.data.message",
                get(e, "response.data.error", "Error")
              ),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );

            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  toggleActivate = async () => {
    try {
      await toggleActivateSAERequest(
        get(this.props, "subject.code", this.state.subjectID),
        get(this.props, "id", this.state.id),
        this.state.saeState
      );
      this.setState({
        requestResult: { type: "success", message: "Success" },
        saeState: this.state.saeState === "inactive" ? "active" : "inactive",
      });
      this.hideDeleteModal();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  deleteSae = async () => {
    const { SAEDeletePermission } = this.props;

    if (SAEDeletePermission) {
      try {
        await deleteSAERequest(this.props.subjectID, this.props.id);
        this.props.onDelete();
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
        }
      }
    }
  };

  showDeleteModal = () => {
    this.setState({ deleteSubmitModal: true });
  };
  hideDeleteModal = () => {
    this.setState({ deleteSubmitModal: false });
  };

  handleSiteIDChange = async (val) => {
    this.setState(
      { siteID: val, responseMessage: "", sae: null },
      this.searchSae
    );
  };

  onSwitchLock = async () => {
    try {
      if (this.state.locked) {
        await unlockSAERequest(
          get(this.props, "subject.code", this.state.subjectID),
          get(this.props, "id", this.state.id)
        );
        this.setState({ locked: false });
      } else {
        await lockSAERequest(
          get(this.props, "subject.code", this.state.subjectID),
          get(this.props, "id", this.state.id)
        );
        this.setState({ locked: true });
      }
      message.success("Saved");
    } catch (e) {
      message.error(get(e, "response.data.error", "Error"));
    }
  };

  render() {
    const {
      isLoading,
      requestResult,
      wasCreated,
      deleteSubmitModal,
      sites,
      locked,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      SAEDeletePermission,
      SAEUpdatePermissionBySite,
      SAEUpdatePermission,
      SAELockPermission,
      SAEUnlockPermission,
      SAECentralCommentsReadPermission,
      SAETermCodesViewPermission,
      SAETermCodesUpdatePermission,
      SAECentralCommentsUpdatePermission,
    } = this.props;
    let isEventTypeOther = getFieldValue("event_type")
      ? this.props.form.getFieldValue("event_type") === "other"
      : this.props.event_type === "other";
    let isSAEOccured = getFieldValue("is_sae_occurred") === "true";
    let isAdverseEventExpected =
      getFieldValue("is_adverse_event_expected") === "true";

    const isEditing = this.state.wasCreated
      ? SAEUpdatePermission
      : this.props.sae_date
      ? SAEUpdatePermissionBySite && !locked
      : true;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">Has a SAE occurred?</h4>

          <div>
            <Form.Item>
              {getFieldDecorator("is_sae_occurred", {
                rules: [{ required: true, message: "Required" }],
                initialValue: this.props.is_sae_occurred
                  ? this.props.is_sae_occurred.toString()
                  : "false",
              })(
                <Radio.Group disabled={!isEditing}>
                  <Radio value="true">Yes</Radio>
                  <Radio value="false">No</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </div>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <b>SubjectID:</b>
                <Form.Item>
                  {getFieldDecorator("subjectID", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "subject.code", ""),
                  })(
                    <Input
                      disabled={
                        !isEditing || !!(this.props.sae_date || wasCreated)
                      }
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col lg={12}>
              <label>
                <b>Site ID</b>
                <Form.Item>
                  {getFieldDecorator("site_id", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "site.id"),
                  })(
                    <Select
                      disabled={!isEditing}
                      placeholder="Select Site ID"
                      style={{ width: "100%" }}
                      allowClear
                    >
                      {sites.map((site) => (
                        <Option key={site.id} value={site.id}>
                          {site.code} - {site.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {this.props.code && (
            <Row gutter={12}>
              <Col lg={6}>
                <label>
                  <b>SAE code:</b>
                  <Form.Item>
                    <Input disabled={true} value={this.props.code} />
                  </Form.Item>
                </label>
              </Col>
              <Col lg={6}>
                <label>
                  <b>SAE event number:</b>
                  <Form.Item>
                    <Input disabled={true} value={this.props.code.split('-')[2]} />
                  </Form.Item>
                </label>
              </Col>
            </Row>
          )}

          {isSAEOccured && (
            <div>
              <p>
                An expected adverse event is one that is a known complication of
                the disease or treatment under study. For example, aspiration
                pneumonia, seizure, UTI, symptomatic ICH area known (expected)
                serious complication of stroke and its treatment. The underlying
                cause of the event is not considered when determining if an
                event is expected or not.
              </p>

              <Row gutter={12}>
                <Col lg={12}>
                  <b>Was the adverse event expected?</b>
                  <Form.Item>
                    {getFieldDecorator("is_adverse_event_expected", {
                      rules: [{ required: true, message: "Required" }],
                      initialValue:
                        this.props.is_adverse_event_expected !== undefined &&
                        this.props.is_adverse_event_expected !== null
                          ? this.props.is_adverse_event_expected.toString()
                          : "null",
                    })(
                      <Radio.Group disabled={!isEditing}>
                        <Radio value="true">Yes</Radio>
                        <Radio value="false">No</Radio>
                        <Radio value="null">Unknown</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>

                  <br />

                  <label>
                    <b>If expected, please indicate type of event</b>
                    <Form.Item>
                      {getFieldDecorator("event_type", {
                        rules: [
                          {
                            required: isAdverseEventExpected,
                            message: "Required",
                          },
                        ],
                        initialValue: this.props.event_type,
                      })(
                        <Select
                          disabled={!isEditing}
                          placeholder="Select type of event"
                        >
                          <Option value="symptomatic_intracerebral">
                            Symptomatic intracerebral hemorrhage
                          </Option>
                          <Option value="peripheral_bleeding">
                            Peripheral bleeding requiring blood transfusion
                          </Option>
                          <Option value="angioedema">Angioedema</Option>
                          <Option value="other">
                            Others (give diagnosis, if possible)
                          </Option>
                          <Option value="none">None</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>

                  <label>
                    <b>SAE Related</b>
                    <Form.Item>
                      {getFieldDecorator("sae_related", {
                        // rules: [{ required: true, message: 'Required' }],
                        initialValue:
                          typeof this.props.sae_related === "boolean"
                            ? this.props.sae_related.toString()
                            : null,
                      })(
                        <Select
                          disabled={!SAEUpdatePermission}
                          placeholder="Select"
                        >
                          <Option value="true">Yes</Option>
                          <Option value="false">No</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </label>
                </Col>
                <Col lg={12}>
                  <label>
                    <b>Date</b>
                    <Form.Item>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "340px",
                        }}
                      >
                        {getFieldDecorator("sae_date", {
                          rules: [{ required: true, message: "Required" }],
                          initialValue: this.props.sae_date
                            ? moment.utc(this.props.sae_date).tz(
                                this.props.userTimezone ||
                                  get(
                                    find(
                                      sites,
                                      ({ id }) =>
                                        id === getFieldValue("site_id")
                                    ),
                                    "time_zone"
                                  ) ||
                                  "UTC"
                              )
                            : moment.utc(new Date()).tz(
                                this.props.userTimezone ||
                                  get(
                                    find(
                                      sites,
                                      ({ id }) =>
                                        id === getFieldValue("site_id")
                                    ),
                                    "time_zone"
                                  ) ||
                                  "UTC"
                              ),
                        })(
                          <DatePicker
                            disabled={!isEditing}
                            format="YYYY/MM/DD"
                            disabledDate={(currentDate) =>
                              currentDate.diff(moment.now()) > 86400000
                            }
                          />
                        )}

                        <span style={{ width: "35px" }}>
                          &nbsp;
                          {this.props.userShortTimezone ||
                            get(
                              find(
                                sites,
                                ({ id }) => id === getFieldValue("site_id")
                              ),
                              "short_tz"
                            ) ||
                            "UTC"}
                        </span>
                      </div>
                    </Form.Item>
                  </label>

                  <br />

                  {isEventTypeOther && (
                    <label>
                      <b>If other, please indicate what event occurred:</b>
                      <Form.Item>
                        {getFieldDecorator("other_event_comments", {
                          rules: [{ required: true, message: "Required" }],
                          initialValue: this.props.other_event_comments,
                        })(<Input.TextArea disabled={!isEditing} />)}
                      </Form.Item>
                    </label>
                  )}
                </Col>
              </Row>

              <label>
                SAE comments
                <br />
                <Form.Item>
                  {getFieldDecorator("event_comments", {
                    initialValue: this.props.event_comments || "",
                  })(<Input.TextArea disabled={!isEditing} rows="3" />)}
                </Form.Item>
              </label>
              {SAECentralCommentsReadPermission && (
                <label>
                  Central SAE comments
                  <br />
                  <Form.Item>
                    {getFieldDecorator("central_sae_comments", {
                      initialValue: this.props.central_sae_comments || "",
                    })(
                      <Input.TextArea
                        disabled={!SAECentralCommentsUpdatePermission}
                        rows="3"
                      />
                    )}
                  </Form.Item>
                </label>
              )}

              {SAETermCodesViewPermission && (this.props.sae_date || this.state.wasCreated) && (
                <div>
                  <Row gutter={12}>
                    <Col lg={6}>
                      <label>
                        LLT Term
                        <br />
                        <Form.Item>
                          {getFieldDecorator("LLT_term", {
                            initialValue: this.props.LLT_term || "",
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        LLT Code
                        <br />
                        <Form.Item>
                          {getFieldDecorator("LLT_code", {
                            initialValue: this.props.LLT_code || "",
                            rules: [
                              {
                                pattern: /^[0-9]{8}$/,
                                message: "8-digit numeric code is allowed",
                              },
                            ],
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col lg={6}>
                      <label>
                        PT Term
                        <br />
                        <Form.Item>
                          {getFieldDecorator("PT_term", {
                            initialValue: this.props.PT_term || "",
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        PT Code
                        <br />
                        <Form.Item>
                          {getFieldDecorator("PT_code", {
                            initialValue: this.props.PT_code || "",
                            rules: [
                              {
                                pattern: /^[0-9]{8}$/,
                                message: "8-digit numeric code is allowed",
                              },
                            ],
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col lg={6}>
                      <label>
                        HLT Term
                        <br />
                        <Form.Item>
                          {getFieldDecorator("HLT_term", {
                            initialValue: this.props.HLT_term || "",
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        HLT Code
                        <br />
                        <Form.Item>
                          {getFieldDecorator("HLT_code", {
                            initialValue: this.props.HLT_code || "",
                            rules: [
                              {
                                pattern: /^[0-9]{8}$/,
                                message: "8-digit numeric code is allowed",
                              },
                            ],
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col lg={6}>
                      <label>
                        HLGT Term
                        <br />
                        <Form.Item>
                          {getFieldDecorator("HLGT_term", {
                            initialValue: this.props.HLGT_term || "",
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        HLGT Code
                        <br />
                        <Form.Item>
                          {getFieldDecorator("HLGT_code", {
                            initialValue: this.props.HLGT_code || "",
                            rules: [
                              {
                                pattern: /^[0-9]{8}$/,
                                message: "8-digit numeric code is allowed",
                              },
                            ],
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                  </Row>

                  <Row gutter={12}>
                    <Col lg={6}>
                      <label>
                        SOC Term
                        <br />
                        <Form.Item>
                          {getFieldDecorator("SOC_term", {
                            initialValue: this.props.SOC_term || "",
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                    <Col lg={6}>
                      <label>
                        SOC Code
                        <br />
                        <Form.Item>
                          {getFieldDecorator("SOC_code", {
                            initialValue: this.props.SOC_code || "",
                            rules: [
                              {
                                pattern: /^[0-9]{8}$/,
                                message: "8-digit numeric code is allowed",
                              },
                            ],
                          })(
                            <Input disabled={!SAETermCodesUpdatePermission} />
                          )}
                        </Form.Item>
                      </label>
                    </Col>
                  </Row>
                </div>
              )}

              <p>
                If the adverse event was serious, unexpected and related, it is
                a Serious Unexpected Adverse Drug Reaction (SUADR). Please
                report details in narrative review form bellow.
              </p>

              <h4 className="headline-default">
                Serious Unexpected Adverse Drug Reaction (SUADR)
              </h4>

              <p>
                NARRATIVE/DETAILS
                <br />
                Please describe the SUADR, treatment and outcome. Please also
                include relevant medical history, any relevant abs or tests
                performed, and any medications given to the patient. Please
                describe the resolution of the event (continuing, resolved,
                death).
              </p>

              <Form.Item>
                {getFieldDecorator("other_comments", {
                  initialValue: this.props.other_comments || "",
                })(<Input.TextArea disabled={!isEditing} rows="6" />)}
              </Form.Item>
            </div>
          )}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <Form.Item className={classes.formActions}>
            <Button
              type="default"
              size="large"
              htmlType="button"
              onClick={this.props.onCancel}
            >
              Back
            </Button>
            &nbsp;&nbsp;
            {(this.props.sae_date || this.state.wasCreated) && (
              <Tooltip placement="topLeft" title="Lock / Unlock the SAE record">
                Lock status: &nbsp;
                <Switch
                  disabled={
                    (!SAEUnlockPermission && locked) ||
                    (!SAELockPermission && !locked)
                  }
                  checked={!locked}
                  onChange={this.onSwitchLock}
                />
              </Tooltip>
            )}
            {/*<Button type="danger" size="large" htmlType="button" style={{ backgroundColor: '#f00', borderColor: '#f00', color: '#fff' }} onClick={this.deleteSae}>
                  Delete
                </Button>*/}
            {this.props.sae_date &&
              !wasCreated &&
              SAEDeletePermission &&
              isEditing && (
                <Button
                  type="default"
                  size="large"
                  htmlType="button"
                  style={{
                    backgroundColor: "#f56009",
                    borderColor: "#f56009",
                    color: "#fff",
                  }}
                  onClick={this.showDeleteModal}
                >
                  {this.state.saeState === "inactive"
                    ? "Activate"
                    : "Deactivate"}
                </Button>
              )}
            {(isEditing || SAETermCodesUpdatePermission) && (
              <Button type="primary" size="large" htmlType="submit">
                Save
                {isLoading && <Icon type="loading" />}
              </Button>
            )}
          </Form.Item>
        </Form>

        <Modal
          title={`SAE ${
            this.state.saeState === "inactive" ? "Activate" : "Deactivate"
          }`}
          visible={deleteSubmitModal}
          onOk={this.toggleActivate}
          onCancel={this.hideDeleteModal}
        >
          <p>
            Confirm SAE{" "}
            {this.state.saeState === "inactive" ? "activate" : "deactivate"}{" "}
            action
          </p>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  SAEUpdatePermission: getSAEUpdatePermission(state),
  SAEUpdatePermissionBySite: getSAEUpdatePermissionBySite(
    get(props, "site.id")
  )(state),
  SAEDeletePermission: getSAEDeletePermissionBySite(get(props, "site.id"))(
    state
  ),
  SAELockPermission: getSAELockPermission(state),
  SAEUnlockPermission: getSAEUnlockPermission(state),
  SAECentralCommentsReadPermission: getSAECentralCommentsReadPermission(state),
  SAECentralCommentsUpdatePermission: getSAECentralCommentsUpdatePermission(
    state
  ),
  SAETermCodesViewPermission: getSAETermCodesViewPermission(state),
  SAETermCodesUpdatePermission: getSAETermCodesUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "saeReporting" })(
  connect(mapStateToProps, mapDispatchToProps)(SAEReportingForm)
);



// WEBPACK FOOTER //
// ./src/components/SAEReportingForm/SAEReportingForm.js